// @flow
import { uniqBy } from 'lodash';
import { pipe } from 'ramda';
import setCookieParser from 'set-cookie-parser';

import type { Receiver, ReceiverState } from './types';

export const fallBackEmptyReceiverIds = (receivers: Array<Receiver>): Array<Receiver> =>
  receivers.map((receiver: Receiver) => {
    if (typeof receiver.receiver_id !== 'string') {
      if (typeof receiver.naked_receiver_id === 'number') {
        return { ...receiver, receiver_id: `R${receiver.naked_receiver_id}` };
      }

      if (typeof receiver.sge_receiver_id === 'string') {
        return { ...receiver, receiver_id: receiver.sge_receiver_id.replace(/dish/, 'R') };
      }
    }
    return receiver;
  });

const lowerCaseReceiverState = (receivers: Array<Receiver>): Array<Receiver> =>
  receivers.map((receiver: Receiver) => {
    const { state } = receiver;
    const lowerCaseState: ReceiverState = state ? (state.toLowerCase(): any) : null;
    receiver.state = lowerCaseState;
    return receiver;
  });

export const getListOfUniqueReceivers = (receivers: Array<Receiver>): Array<Receiver> =>
  uniqBy(receivers, receiver => receiver.receiver_id);

/*
  1) Fallbacks empty receiver_ids with id from naked_receiver_id or sge_receiver_id
  2) formats "state" field
  3) removes duplicates
*/
export const normalizeReceiversList = (receivers: Array<Receiver>) =>
  pipe(
    fallBackEmptyReceiverIds,
    lowerCaseReceiverState,
    getListOfUniqueReceivers,
  )(receivers);

export const parseRadishSetCookie = (setCookieHeader: string) => {
  const splitCookieHeaders = setCookieParser.splitCookiesString(setCookieHeader);
  const cookies = setCookieParser.parse(splitCookieHeaders, { map: true });
  return cookies?.rs;
};
